import { apiErrorCode, extractApiError } from "./apiErrors";

/**
 * The localized sentence for a blog write/read refusal (contract sections 2-4).
 * `t` is `useT("superadmin")`. A code this file does not name falls through to the shared
 * `extractApiError`, so a 5xx or a network failure still reads sensibly.
 *
 * @param {unknown} err the rejected axios error
 * @param {(key: string, vars?: object, fallback?: string) => string} t
 * @returns {string}
 */
export function blogErrorMessage(err, t) {
  switch (apiErrorCode(err)) {
    case "BLOG_SLUG_TAKEN":
      return t("hqblog.err.slugTaken");
    case "BLOG_NO_LANGUAGE":
      return t("hqblog.err.noLanguage");
    case "BLOG_POST_NOT_FOUND":
      return t("hqblog.err.notFound");
    case "BLOG_LANGUAGE_INCOMPLETE": {
      const detail = err?.response?.data?.detail;
      return t("hqblog.err.languageIncomplete", { lang: t(`hqblog.lang.${detail?.lang}`) });
    }
    default:
      return extractApiError(err, t("hqblog.error"), t);
  }
}
